import { render, staticRenderFns } from "./FormOpenHours.vue?vue&type=template&id=a2e6ef3c&scoped=true"
import script from "./FormOpenHours.vue?vue&type=script&lang=js"
export * from "./FormOpenHours.vue?vue&type=script&lang=js"
import style0 from "./FormOpenHours.vue?vue&type=style&index=0&id=a2e6ef3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e6ef3c",
  null
  
)

/* custom blocks */
import block0 from "./FormOpenHours.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports